import { useState } from 'react';

export default function Input({
  label,
  type = 'text',
  error,
  placeholder,
  value,
  onChange,
  required = false,
  className = '',
  ...props
}) {
  const [showPwd, setShowPwd] = useState(false);
  const isPassword = type === 'password';

  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label className="form-label">
          {label} {required && <span style={{ color: 'var(--elvyra-danger)' }}>*</span>}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        <input
          type={isPassword ? (showPwd ? 'text' : 'password') : type}
          className={`form-input ${error ? 'error' : ''}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          style={{ width: '100%', paddingRight: isPassword ? 44 : undefined }}
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPwd(p => !p)}
            style={{
              position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
              background: 'none', border: 'none', color: 'var(--elvyra-text-muted)',
              fontSize: 16, cursor: 'pointer',
            }}
          >
            {showPwd ? '🙈' : '👁'}
          </button>
        )}
      </div>
      {error && <span className="form-error">{error}</span>}
    </div>
  );
}
